import type { PointerEvent } from "react"

// Dialogs close on a backdrop click. A `click` fires on the common ancestor of the
// press and the release, so a text-selection drag that starts inside the content and
// ends over the backdrop would register as a backdrop click on the <dialog> itself.
// Require the press AND the release to land on the backdrop instead. (The ::backdrop
// pseudo-element reports the <dialog> as the event target, so target === currentTarget
// means "on the backdrop".)
const pressed = new WeakSet<Element>()

export function backdropDismiss(onDismiss: () => void) {
  return {
    onPointerDown(e: PointerEvent<HTMLDialogElement>) {
      if (e.target === e.currentTarget) pressed.add(e.currentTarget)
      else pressed.delete(e.currentTarget)
    },
    onPointerUp(e: PointerEvent<HTMLDialogElement>) {
      const armed = pressed.delete(e.currentTarget)
      if (armed && e.target === e.currentTarget) onDismiss()
    },
  }
}
